export default __webpack_public_path__ + "static/Hack-Italic-ea5195c1935da4a6011684a9520d4d67.woff";